import React, { useEffect, useState } from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "../../../shared/components/skeletons/AutocompleteSkeleton";
import {
  capitalizeWords,
  finderServicioByName,
} from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  examenProcedimientoByServiceState,
  serviciosState,
  sucursalesState,
} from "./state/atoms";

import {
  procedimientoByServiceState,
  procedimientosState,
  specialitiesByServiceState,
  specialitiesState,
  professionalsByServiceState,
  professionalsState,
} from "./state/atoms";
import SucursalIcon from "src/shared/icons/SucursalIcon";
import ServicioIcon from "src/shared/icons/ServicioIcon";

const AutocompleteServicio = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loading, setLoading] = useState(false);
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const servicios = useRecoilValue(serviciosState);
  const [procedimientos, setProcedimientos] =
    useRecoilState(procedimientosState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState,
  );
  const sucursales = useRecoilValue(sucursalesState);
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState,
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const resetProcedimientos = useResetRecoilState(procedimientosState);

  const loadSpeciality = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          let servicioCode = filterSearchSelected.servicioSelected.code;
          let sue_correl = filterSearchSelected.sucursalSelected.sue_correl;

          const reduceSueCorrel = sucursales.reduce((acc, item, idx, src) => {
            if (idx === src.length - 1) {
              acc = acc + item.sueCorrel;
            } else {
              acc = acc + item.sueCorrel + "_";
            }
            return acc;
          }, "");

          sue_correl = sue_correl ? sue_correl : reduceSueCorrel;

          if (servicioCode != null) {
            const procedimientosFetch = await snapshot.getPromise(
              examenProcedimientoByServiceState({
                serviceCode: servicioCode,
                sue_correl,
              }),
            );
            const responses = await Promise.all([procedimientosFetch]);
            setProcedimientos(responses[0]);
          }
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [filterSearchSelected.servicioSelected.value],
  );

  useEffect(() => {
    loadSpeciality();

    // return () => {
    //     loadSpeciality();
    // }
  }, [loadSpeciality]);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-servicio"
        text="Servicio"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-servicio"
        options={servicios && servicios.map((option) => `${option.aseDescrip}`)}
        //options={sucursales.map((option) => `${option.serNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.servicioSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetProcedimientos();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
              procedimientoSelected: {
                ...filterSearchSelected.procedimientoSelected,
                value: "",
                code: null,
              },
              servicioSelected: {
                ...filterSearchSelected.servicioSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findServicio = finderServicioByName(servicios, value);
            setFilterSearchSelected({
              ...filterSearchSelected,
              servicioSelected: {
                ...filterSearchSelected.servicioSelected,
                value: value,
                code: findServicio?.aseCorrel,
              },
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
              procedimientoSelected: {
                ...filterSearchSelected.procedimientoSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Servicio" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <ServicioIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteServicio;
